// extracted by mini-css-extract-plugin
export default {"FooterBar":"FooterBar_FooterBar__E6opc"};